import React, { Component } from 'react';
import RugBrands from './filters/brands';
import DownArrowSVG from '../svgDownArrow';
import RugYarns from './filters/yarns';
import RugShanehs from './filters/shanehs';
import RugDensities from './filters/densities';

export default class RugsFilterListMobile extends Component {

    constructor(props) {
        super(props)
        this.state = {
            filter: false,
            activeFilters: ["brands", "yarns", "shanehs"]
        }
    }

    filterHandler = (filter) => {
        let finalArray = this.state.activeFilters
        if (finalArray.indexOf(filter) === -1) {
            finalArray.push(filter)
        } else {
            finalArray.splice(finalArray.indexOf(filter), 1)
        }
        this.setState({ activeFilters: finalArray })
    }

    render() {
        return (
            <div className={`text-center filter-mobile-list ${this.state.filter ? "active" : ""}`}>
                 {/* give the active className to upper div for show ul and list*/}
                <div className="head-cover">
                    <div className="text-filter" onClick={() => this.setState({filter: !this.state.filter})}>
                        <p> {this.props.texts["filters"]}
                            <DownArrowSVG />
                        </p>
                    </div>
                </div>
                <ul className="relative button-body">
                    <li className={this.state.activeFilters.indexOf("brands") !== -1 ? "head-filter active" : "head-filter"} onClick={() => this.filterHandler("brands")}> {this.props.texts["brand"]}
                        <DownArrowSVG />
                    </li>
                    <RugBrands activeFilters={this.state.activeFilters} changeHandler={this.props.filterChangeHandler} selectedBrands={this.props.brands} />

                    <li className={this.state.activeFilters.indexOf("yarns") !== -1 ? "head-filter active" : "head-filter"} onClick={() => this.filterHandler("yarns")}> {this.props.texts["yarn"]} <DownArrowSVG /> </li>
                    <RugYarns activeFilters={this.state.activeFilters} changeHandler={this.props.filterChangeHandler} selectedYarns={this.props.yarns} />

                    <li className={this.state.activeFilters.indexOf("shanehs") !== -1 ? "head-filter active" : "head-filter"} onClick={() => this.filterHandler("shanehs")}> {this.props.texts["shaneh"]} <DownArrowSVG /> </li>
                    <RugShanehs activeFilters={this.state.activeFilters} changeHandler={this.props.filterChangeHandler} selectedShanehs={this.props.shanehs} />

                    <li className={this.state.activeFilters.indexOf("densities") !== -1 ? "head-filter active" : "head-filter"} onClick={() => this.filterHandler("densities")}> {this.props.texts["density"]} <DownArrowSVG /> </li>
                    <RugDensities activeFilters={this.state.activeFilters} changeHandler={this.props.filterChangeHandler} selectedShanehs={this.props.shanehs} selectedDensities={this.props.densities} />
                </ul>
            </div>
        )
    }
}